import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { useFlag } from 'hook/flag.hook';
import React from 'react';
import { AUTO_DD_SUCCESS } from 'types/morph.pagePosition.constants';
import AutoDDSuccessView from './AutoDDSuccessView';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';

const AutoDDSuccessControlller = props => {
  const atr = getViewModuleTrackingAttributes({
    pagePosition: AUTO_DD_SUCCESS,
    modulePosition: props.modulePosition,
    moduleType: AUTO_DD_SUCCESS,
    vertical: BANKING_VERTICAL,
  });
  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);
  const cashFlag = useFlag('cash');
  const config =
    cashFlag?.config?.module_auto_dd_success?.allSegmentsScoreCopy ?? {};

  const onClickExploreSesameCash = () => {
    props?.eventHandler(CLICK, {
      'Click Type': 'Return to Dashboard',
      ...atr,
    });
    props?.history?.push('/cash');
  };

  const onClickOneTimeTransfer = () => {
    props?.eventHandler(CLICK, {
      'Click Type': 'Load via ACH',
      ...atr,
    });
    props?.history?.push('/cash/cashAccount/transferOptions/bankTransfer');
  };

  return (
    <AutoDDSuccessView
      {...config}
      seenPixel={seenPixel}
      onClickExploreSesameCash={onClickExploreSesameCash}
      onClickOneTimeTransfer={onClickOneTimeTransfer}
    />
  );
};

export default AutoDDSuccessControlller;
